<div class="btn-container">
  <button class="button" (click)="pdf()">
    <i class="pi pi-file-pdf" style="font-size: 1.5rem; color: white"></i>
  </button>
</div>